<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 mt-4" style="position: relative">
      <v-layout wrap>
        <v-flex xs12 sm6>
          <span class="main-title">SUMMARY | &nbsp;</span>
          <span class="submain-title">Promotion report</span>
        </v-flex>
        <v-flex
          xs12
          sm6
          style="display:flex;align-items:center;justify-content:flex-end"
        >
          <download-excel
            :data="export_promotion_format"
            :fields="{
              No: 'No',
              'Promotion name': 'promotion_name',
              Discount: 'discount',
              Amount: 'amount',
              'Used/Cancel': 'used_cancel',
              'Value price(THB)': 'total_value_price',
              'Paid price(THB)': 'total_paid_price',
            }"
            :name="
              'PromotionReport_' +
                search_config.datetime_start +
                '_to_' +
                search_config.datetime_end +
                '.xls'
            "
          >
            <v-btn flat> <v-icon large color="black">print</v-icon>.xls </v-btn>
          </download-excel>
          <download-excel
            type="csv"
            :data="export_promotion_format"
            :fields="{
              No: 'No',
              'Promotion name': 'promotion_name',
              Discount: 'discount',
              Amount: 'amount',
              'Used/Cancel': 'used_cancel',
              'Value price(THB)': 'total_value_price',
              'Paid price(THB)': 'total_paid_price',
            }"
            :name="
              'PromotionReport_' +
                search_config.datetime_start +
                '_to_' +
                search_config.datetime_end +
                '.csv'
            "
          >
            <v-btn flat><v-icon large color="black">print</v-icon>.csv </v-btn>
          </download-excel>
        </v-flex></v-layout
      >
    </div>
    <searchDateStartToEnd :searching="searching" @search="searchList()" />
    <promotionReportList />
  </div>
</template>

<script>
import { mapState } from "vuex";
import searchDateStartToEnd from "@/components/back-office/Report/SearchBar/SearchDateStartToEnd";
import promotionReportList from "@/components/back-office/Report/PromotionReportList";
export default {
  data() {
    return {
      searching: false,
    };
  },
  components: {
    promotionReportList,
    searchDateStartToEnd,
  },
  destroyed() {
    this.$store.commit("fetchPromotionReport/resetState");
  },
  computed: {
    ...mapState({
      export_promotion_format: (state) =>
        state.fetchPromotionReport.export_promotion_format,
      search_config: (state) => state.fetchPromotionReport.clone_config_path,
    }),
  },
  methods: {
    async searchList() {
      this.searching = true;
      if (
        this.$store.state.fetchPromotionReport.config_path.district_id[0] == 0
      ) {
        await this.$store.dispatch(
          "fetchPromotionReport/fetchReportList",
          this.$store.state.fetchPromotionReport.config_path
        );
      } else {
        await this.$store.dispatch(
          "fetchPromotionReport/fetchReportListByDistrict"
        );
      }
      this.searching = false;
    },
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard",
      },
      {
        text: "Promotion report",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
</style>
